import _ from "underscore";

("use strict");

const ObservingSession = {
	getObservingSessionsBySite: (site) => {
		var observingSessionsWithThisSite = _.filter(
			Portal.Current.Collections.observingSessions,
			(observingSession) => {
				if (
					observingSession.get("site") &&
					observingSession.get("site").id === site.id
				) {
					return observingSession;
				}
			},
		);
		return observingSessionsWithThisSite;
	},
};

export default ObservingSession;
